var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$routerHistory.hasPrevious())?_c('router-link',{staticStyle:{"color":"#fff"},attrs:{"to":{ path: _vm.$routerHistory.previous().path }}},[_c('b-icon-arrow-left')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }